import { useEffect, useRef } from 'react';
import { categories } from './data';

export default function HelpSidebar({
    activeCategory,
    onSelect,
}: {
    activeCategory: string;
    onSelect: (id: string) => void;
}) {
    const activeRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        activeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }, [activeCategory]);

    return (
        <div className="flex gap-2 overflow-x-auto pb-2 sm:grid sm:grid-cols-3 sm:overflow-visible sm:pb-0 md:grid-cols-4 lg:flex lg:w-66 lg:shrink-0 lg:flex-col lg:gap-1">
            {categories.map((cat) => {
                const Icon = cat.icon;
                const isActive = cat.id === activeCategory;

                return (
                    <button
                        key={cat.id}
                        ref={isActive ? activeRef : undefined}
                        type="button"
                        onClick={() => onSelect(cat.id)}
                        className={`group relative flex shrink-0 items-center gap-2 overflow-hidden rounded-xl px-3 py-2.5 text-left text-xs font-medium transition-all duration-200 cursor-pointer sm:gap-3 sm:px-4 sm:py-3 sm:text-sm
                            ${isActive
                                ? 'bg-btn text-btn-foreground shadow-sm'
                                : 'text-foreground hover:bg-muted'
                            }`}
                    >
                        {/* Active indicator bar — desktop only */}
                        <span
                            className={`absolute left-0 top-1/2 hidden h-5 w-0.75 -translate-y-1/2 rounded-full bg-primary transition-all duration-300 lg:block
                                ${isActive ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'}`}
                        />

                        {/* Icon */}
                        <span className={`shrink-0 transition-transform duration-200 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`}>
                            <Icon className={isActive ? 'text-btn-foreground' : 'text-text-light'} />
                        </span>

                        {/* Label */}
                        <span className={`whitespace-nowrap transition-all duration-200 ${isActive ? 'font-bold translate-x-0.5' : 'group-hover:translate-x-0.5'}`}>
                            {cat.label}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
